// extracted by mini-css-extract-plugin
module.exports = {"topDiv":"Quote_topDiv__2ECIP","quote":"Quote_quote__1xSut"};